export default {"src":"/_next/static/media/stressMotivation.1545766b.svg","height":617,"width":1048,"blurWidth":0,"blurHeight":0};